define('app/views/search_view',['app/setup'], function(takhfifan) {

  takhfifan.SearchView = takhfifan.BaseView.extend({

    renewSearch: function() {
      window.location.href = '/catalogsearch/result/?q='
      + this.$("#search-field").val();
    },

    updateQueryWithTimer : function(ev) {
      var _this = this;

      $("input").on('keyup', function() {
        clearInterval(_this.queryTimer);
        _this.queryTimer = setTimeout(function() {
          _this.renewSearch();
        }, 800);
      });
    },

    updateBrand: function(ev) {
      var _this = this;
      if($(ev.currentTarget).prop('checked')==true)  {
        if(_.isUndefined(this.collection.brand)) {
          this.collection.brand={};
        }
        this.collection.brand[$(ev.currentTarget).val()] = $(ev.currentTarget).val();
      }
      else {
        if(this.collection.brand &&
           this.collection.brand[$(ev.currentTarget).val()]) {
          delete this.collection.brand[$(ev.currentTarget).val()];
        }
      }
      _this.collection.pageNum = undefined;
      if(this.collectionAbruptFetch) {
        this.collection.fetch({reset: true});
      }
    },
    
    updateCategory: function(ev) {
      $('.wrapper').before('<div class="search-loading"></div>');
      var _this = this;
      if($(ev.currentTarget).prop('checked')==true)  {
        if(_.isUndefined(this.collection.categoryId)) {
          this.collection.categoryId={};
        }
        this.collection.categoryId[$(ev.currentTarget).val()] = $(ev.currentTarget).val();
      }
      else {
        if(this.collection.categoryId &&
           this.collection.categoryId[$(ev.currentTarget).val()]) {
          delete this.collection.categoryId[$(ev.currentTarget).val()];
        }
      }
      _this.collection.pageNum = undefined;
      if(this.collectionAbruptFetch) {
        this.collection.fetch({reset: true}).always(function(){ $('.search-loading').remove(); });
      }
    },

    updatePriceRange: function(ev) {
      var _this = this;
      _.delay(function() {
        if(!_this.isAlreadyUpdating) {
          if(_this.$(".tkhUpperPriceValue").val()!=_this.currentUpperPrice || _this.$(".tkhLowerPriceValue").val()!=_this.currentLowerPrice) {
            $('.wrapper').before('<div class="search-loading"></div>');
            _this.isAlreadyUpdating=true;
            _this.collection.maxPrice=_this.$(".tkhUpperPriceValue").val();
            _this.collection.minPrice=_this.$(".tkhLowerPriceValue").val();
            _this.collection.pageNum = undefined;
            if(_this.collectionAbruptFetch) {
                _this.collection.fetch({reset: true , success: function () {
                  _this.isAlreadyUpdating=false;
                  _this.currentUpperPrice=_this.collection.maxPrice;
                  _this.currentLowerPrice=_this.collection.minPrice;
                },
                error: function(data, a, b){
                  _this.isAlreadyUpdating=false;
                }
              }).always(function(){ $('.search-loading').remove(); });
            }
            else {
              _this.isAlreadyUpdating=false;
            }
          }
        }
      }, 500);
    },

    updateQuery: function(ev) {
      this.renewSearch();
    },

    isOnScreen: function(obj) {
      var $w = this.options.window.$el;
      var top = $w.scrollTop();
      var bottom = top + $w.height();
      var elTop = obj.offset().top;

      return (top < elTop && bottom > elTop);
    }

  });
});

